<template>
    <div id="interactive-chart" class="mt__2">
        <Menu
            ref="menu"
            :selected="selected"
            @select="select"
            @deselect="deselect"
            @select-all="selectAll"
            @deselect-all="deselectAll"
        />
        <Chart ref="chart" :selected="selected" />
    </div>
</template>
<script>
import Menu from './Menu.vue';
import Chart from './Chart.vue';

export default {
    components: {
        Menu,
        Chart
    },
    data() {
        return {
            selected: []
        }
    },
    methods: {
        select( id ) {
            this.selected.push( id );
            this.$emit('selection', this.selected);
        },
        deselect( id ) {
            const idx = this.selected.findIndex(i => i === id);

            if( idx > -1 ) {
                this.selected.splice(idx,1);
                this.$emit('selection', this.selected);
            }
        },
        selectAll() {
            this.selected = rankingChart.topics.map( i => i.topic_id );
            this.$emit('selection', this.selected);
        },
        deselectAll() {
            this.selected = [];
            this.$emit('selection', this.selected);
        }
    }
}
</script>